import { MantineTheme, createStyles } from "@mantine/core";

export const useStyles = createStyles((theme: MantineTheme) => ({
  OuterContainer: {
    backgroundColor: "#F5F6F8", // Softer gray for a modern feel
    padding: "60px 20px", // Increased padding for breathing room
    minHeight: "100vh", // Full height for better layout
    display: "flex",
    justifyContent: "center",
  },
  innerContainer: {
    padding: "0 40px",
    maxWidth: "1200px", // Limit width for readability
    width: "100%",
    backgroundColor: "#FFFFFF", // White card-like background
    borderRadius: "12px", // Rounded corners
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)", // Subtle shadow
  },
  SubHeadingOutterContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "20px", // Consistent spacing between items
    margin: "30px 0",
    flexWrap: "wrap", // Responsive wrapping
  },
  subHeadingContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px", // Space between label and input/select
  },
  closeIcon: {
    position: "absolute",
    right: "30px",
    top: "30px",
    fontSize: "28px",
    cursor: "pointer",
    color: "#666", // Softer color
    transition: "color 0.2s",
    "&:hover": {
      color: "#000", // Darken on hover
    },
  },
  heading: {
    fontSize: "24px", // Slightly larger for emphasis
    fontWeight: 700,
    textAlign: "center",
    padding: "20px 0",
    color: "#1A1A1A", // Darker for contrast
  },
  subHeadingText: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#444", // Subtle color
  },
  KycSelect: {
    width: "160px",
    "& .mantine-Select-dropdown": {
      minWidth: "200px", // Match the minWidth set in the styles prop
    },
  },
  commentInput: {
    width: "300px",
  },
  commentInputForFund: {
    width: "160px",
  },
  listContainer: {
    listStyleType: "none",
    display: "flex",
    justifyContent: "flex-start", // Align left for scrolling
    padding: "0 10px",
    margin: 0,
    borderBottom: "1px solid #E0E4E8",
    backgroundColor: "#F9FAFB",
    borderRadius: "8px 8px 0 0",
    overflowX: "auto", // Enable horizontal scrolling
    whiteSpace: "nowrap", // Keep tabs in a single row
    "&::-webkit-scrollbar": {
      height: "6px", // Thin scrollbar
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#B0B8C4", // Subtle scrollbar color
      borderRadius: "6px",
    },
  },
  listText: {
    textAlign: "center",
    padding: "12px 20px", // More padding for comfort
    fontSize: "14px",
    fontWeight: 500,
    color: "#666",
    cursor: "pointer",
    transition: "all 0.2s",
    flexShrink: 0, // Prevent tabs from shrinking
    "&:hover": {
      backgroundColor: "#EDEFF2",
    },
  },
  stepActive: {
    backgroundColor: "#FFFFFF",
    borderTop: "3px solid #4A90E2",
    borderRadius: "4px 4px 0 0",
    fontWeight: 700,
    color: "#1A1A1A",
    boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.05)",
  },
  contentContainer: {
    backgroundColor: "#FFFFFF",
    padding: "30px",
    borderRadius: "0 0 8px 8px",
    minHeight: "400px", // Ensure content has space
    overflowX: "auto",
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "center",
    padding: "20px 0",
  },
  inviteButton: {
    width: "220px",
  },
  shareHolderWrapper: {
    "& input, & div": {
      maxWidth: "300px", 
      marginRight: "20px",
    },
  },
}));
